import { PanelMember } from '../panel-member.model';
import { Candidate } from '../candidate.model';

export class AutoPanelCreation {
    panelId: number;
    dateOfInterview: string;
    fromTime: string;
    toTime: string;
    panelCnt: number;
    panelMemberCntPerPanel: number;
    candidateCntPerPanel: number;
    meetingService: string;
    constructor(panelCnt: number, panelMemberCntPerPanel: number, candidateCntPerPanel: number, meetingService: string = null) {
        // this.dateOfInterview = dateOfInterview;        
        // this.fromTime = fromTime;        
        // this.toTime = toTime;        
        this.panelCnt = panelCnt;
        this.panelMemberCntPerPanel = panelMemberCntPerPanel;
        this.candidateCntPerPanel = candidateCntPerPanel;
        this.meetingService = meetingService;
    }
}
